// @ts-nocheck
import compareVersions from 'compare-versions';
import { formatCurrency } from '@shopee_common/currency';
import { ChannelType } from '@shopee/shopee-chatbot-agent-chat/dist/types';

import { handleRequest } from '@/utils';
import { addDialogue, addTip, updateDialogueInfo } from '@/utils/sessionUtils';
import { batchPostChatMsg, postChatImg, reviewChatEndText, enableIosBlankDetection } from './agent';
import {
  REDIRECTION_URLS,
  LIVE_CONTEXT_DATA_KEY,
  SessionIDType,
  FIRE_FLAG,
  GetMsgResCode,
  getIosVersionReg,
  HISTORY_TRANSIFY_KEY,
  Copywriting,
  LIVE_AGENT_DATA_KEY,
  isIosReg,
  isAndroidReg,
  SourceInUrl,
  VIRTUAL_CALL_NEED_RECOVER_HISTORY,
} from './constants';
import { initSessionApiFinish } from '@/stores/firstInit';
import {
  initStore,
  userStore,
  sessionStore,
  agentStore,
  sessionIDListStore,
  performanceStore,
  historyStore,
  compareStore,
  firstInitStore,
  modalStore,
} from '@/stores/index';
import { postChatHeartbeat } from '@/services/chat';
import { UploadFileStatus, saveAgentData } from '@/stores/agent';
import * as Toast from '@/utils/Toast';
import { toggleShow } from '@/utils/bridges/chat';
import {
  clearDataFromLocalStorage,
  saveDataToLocalStorage,
  getDataFromLocalStorage,
} from '@/utils/bridges/localStorage';
import { redirectTrack } from '@/utils/tracking/utils/redirectTrack';
import { getOfflineFormUrlWithParams } from '@/utils/getOfflineFormUrlWithParams';
import { trackImageFinish } from './videoTools';
import { initLiveChatSDK, getSDKToken, getLiveChatSDKHttpHeaders, isBankNonLogin } from '@/utils/liveChatToken';
import {
  getTrans,
  getContent,
  handleHeartbeat,
  replaceParams,
  bridgeCallFunc,
  getRecoveryHistory,
  getCookie,
  getFileExtension,
  getAppLink,
  asyncReport,
  getNonShopeeAppLink,
} from './instantLoaded/tools';
import { getScrollElement, getQueryForm, getNavbarHeight } from '@/utils/instantLoaded/toolsWithoutDeps';
import { clearPageInactiveData } from './handlePageInactiveForPN';
import { getChatbotHost, getConfig, getFromInUrl, isBank, UseLiveChatSDKApp } from '@/config/core';
import {
  COUNTRY,
  LIVE_OFFLINE_FORM_URL,
  WEB_FORM_ENTRY_POINT,
  FOOD_OFFLINE_FROM_URL,
  BANK_OFFLINE_FORM_URL,
  BANK_POLICY_URL_FOR_UAT_PH,
  BANK_POLICY_URL_FOR_LIVE_PH,
} from './locale';
import { App, ShopeeEntryPoint } from '@/config/constants';
import { PRE_INIT_SESSION_ID } from './instantLoaded/constants';
import { getChatbotApiQuery } from '@/services/request';
import ChatMessagesArea from '@/components/ChatMessagesArea';
import { safeCallLiveChatSDK } from '@/utils/liveChatSDK';
import { ENTRY_POINT } from '@/types/entryPoints';
import { getDriverWebformUrl } from '@/config/webform/driver';
import { showBankUpdateModal } from '@/components/ChatbotUI/showBankUpdateModal';
import { getInternetCallLink, isInternetCallLink } from './common';
import { addBankToLoginDialogue, clearBeforeRedirectToBankLoginEffect, generateLoginCallbackParams, getFirstMatchParams, handleBeforeRedirectToBankLoginEffect, isPostLoginPages } from './bankNonLoginHelpers';
import { BankUrlMethodParamEnum, isRetainSessionContextSuccess } from './bankLoginHelpers';

export { sendCBHeartbeat, getContent, afterDialogueShow, scrollToBottom, replaceParams } from './instantLoaded/tools';
export { getTrans } from './instantLoaded/getTrans';
export { fixOverlayScroll } from './fixOverlayScroll';

export const isSuccessCode = (code) => code === GetMsgResCode.SUCCESS;

export const handleH5Redirection = (url, extraParams = {}) => {
  if (!url) {
    console.warn('Redirect url should not be empty');
    return;
  }

  const extraConfig = isBank() ? { config: { pageChannel: (url ?? '').startsWith('shopee') ? 1 : 0 } } : {};

  if (isBankUrlMatch(url)) {
    const navbar = extraParams?.navbar || {};
    extraParams.navbar = { ...navbar, liveChatPageType: 'bank' };
  }

  if (isBank() && isBankNonLogin) {
    handleBeforeRedirectToBankLoginEffect();
  }

  bridgeCallFunc(() => {
    try {
      window.bridgeCallHandler(
        'navigate',
        {
          url,
          ...extraParams,
          ...extraConfig,
        },
        (res) => {
          if (isBank()) {
            if (!res.successToJumpPage) {
              if (isBankNonLogin) {
                clearBeforeRedirectToBankLoginEffect();
              }
              // bank PH不会返回任何res
              // bank ID没有callback
              // addTip(getTrans('error_bad_network'));
            }
          } else {
            if (!res.status) {
              addTip(getTrans('error_bad_network'));
            }
          }
        },
      );
    } catch (e) {
      console.error(e);
      clearBeforeRedirectToBankLoginEffect();
    }
  });
};

export const handleBankAppStoreRedirection = () => {
  bridgeCallFunc(() => {
    try {
      window.bridgeCallHandler('lcOpenAppStore', {}, (res) => {
        if (!res.successToOpenAppStore) {
          addTip(getTrans('error_bad_network'));
        }
      });
    } catch (e) {
      console.error(e);
    }
  });
};

export const checkAppVersionSupport = (url: string) => {
  if (!isBank()) {
    return true;
  }

  const platform = process.env.platform;
  if (platform === 'bank' || platform === 'bankID') {
    // chatbot 目前仅支持 id和ph，sg暂时先不管

    // 只有新增的 bank native 页面和跳转 app store 才做版本检查，之前
    // 老的 H5 页面是支持跳转的，所以不需要检查
    const httpReg = /app(-uat1\.uat)?\.seabank\.(ph|co\.id)\/(app|help\-center)/;
    const inAppReg = /^(in-app:)?(r?n)\/(\S+)$/;
    const shopeeReg = /^(in-app:)?shopee(id|ph)/;
    if (shopeeReg.test(url) || inAppReg.test(url) || httpReg.test(url) || url === 'bank_app_store_page') {
      const version = window.getAppVersion();
      if (version < 10200) {
        showBankUpdateModal();
        return false;
      }
    }
  }

  return true;
};

// 跳转统一处理
export const redirectionTo = (key, extraData?: any, extraParams = {}, actionInfo?: { closePopup?: () => void }) => {
  if (!checkAppVersionSupport(key)) {
    return;
  }

  console.log('redirectionTo isPostLoginPages, data=', {
    'isBank()': isBank(),
    isBankNonLogin,
    'isPostLoginPages(key)': isPostLoginPages(key)
  });
  if (isBank() && isBankNonLogin && isPostLoginPages(key)) {
    modalStore.isShowModalArticle && modalStore.HIDE_ARTICLE_MODAL();
    actionInfo?.closePopup?.();
    const callbackParams = generateLoginCallbackParams({
      method: BankUrlMethodParamEnum.redirection,
      methodData: key,
      methodIdName: BankUrlMethodParamEnum.redirection,
    });
    addBankToLoginDialogue({ link: key, callbackParams });
    return;
  }

  if (isBank()) {
    const configedExtraParams = getFirstMatchParams(key);
    extraParams = {
      ...configedExtraParams,
      ...extraParams,
    };
    console.log('redirectionTo getFirstMatchParams, data=', configedExtraParams, extraParams);
  }

  // 这里用来 是否是 internet call
  // 如果是的话 判断当前 app 版本是否支持 不支持的话就不跳转 同时弹出更新提示
  if (isInternetCallLink(key ?? '')) {
    if (!initStore?.initSessionChatConfig?.canUseInternetCall) {
      modalStore.UPDATE_SHOW_MODAL_UPDATE_APP(true);
      return;
    } else {
      key = getInternetCallLink(key ?? '');
      extraData = extraData ?? {};
      extraData.__anim__ = 3;
    }
  }

  enableIosBlankDetection(false);

  const endpoint = REDIRECTION_URLS[key] || {};
  let { url = key } = endpoint;
  // 参数转换
  const { paramsGenerator } = endpoint;
  let { type = 'h5', module, params } = endpoint;
  redirectTrack(endpoint);

  handlePostEndSessionRequest();

  const splitInAppLink = getAppLink(url);
  if (splitInAppLink != null) {
    // rn 或 n
    const inAppLinkType = splitInAppLink[1];
    // rn 或 native 页面链接
    const inAppLinkModule = splitInAppLink[2];

    type = inAppLinkType;
    module = inAppLinkModule;
    params = { module: inAppLinkModule };
  }

  if (isBank()) {
    const splitBankInAppLink = getNonShopeeAppLink(url);
    if (splitBankInAppLink != null) {
      // bank 只支持 navigate bridge，所以 in-app link 也走 h5 跳转逻辑
      type = 'h5';
      url = splitBankInAppLink[1];
    }
  }

  console.log('redirectionTo url', url, 'extraData', extraData);

  if (type === 'h5') {
    let finalUrl = extraData ? replaceParams(url, extraData) : url;
    const csFillToken = getQueryForm('csFillToken', initStore.searchUrl || '');
    if (csFillToken && !finalUrl.includes('csFillToken')) {
      finalUrl = `${finalUrl}${finalUrl.includes('?') ? '&' : '?'}csFillToken=${csFillToken}`;
    }
    handleH5Redirection(finalUrl, extraParams);
  } else if (type === 'rn') {
    const finalUrl = extraData ? replaceParams(module, extraData) : module;
    console.log('rn link ', '/rn/' + finalUrl, 'params', paramsGenerator?.(extraData || {}) || extraData || {});

    bridgeCallFunc(() => {
      bridgeCallHandler('navigateAppRL', {
        apprl: '/rn/' + finalUrl,
        params: paramsGenerator?.(extraData || {}) || extraData || {},
      });
    });
  } else if (type === 'rn-sf') {
    // TODO 待SG Native - Android修复navigateAppRL中对半透明的支持后，沿用原来navigateAppRL方式
    // 针对半透明背景的rating特殊处理
    bridgeCallFunc(() => {
      bridgeCallHandler('navigateAppPath', {
        path: '/rn/' + params.module + '?navigationType=3',
        params: extraData || {},
      });
    });
  } else if (type === 'n') {
    const finalUrl = extraData ? replaceParams(params.module, extraData) : params.module;
    bridgeCallFunc(() => {
      bridgeCallHandler('navigateAppRL', {
        apprl: '/n/' + finalUrl,
        params: extraData || {},
      });
    });
  } else if (type === 'app-store') {
    if (isBank()) {
      handleBankAppStoreRedirection();
    }
  }

  bridgeCallFunc(() => {
    const bridgeCallback = () => {
      enableIosBlankDetection(true);
      window.bridgeUnRegisterHandler('viewWillReappear', bridgeCallback);
    };
    window.bridgeRegisterHandler('viewWillReappear', bridgeCallback);
  });
};

export const handlePostEndSessionRequest = () => {
  if (initStore.sessionToken && initStore.sessionId) {
    try {
      const body = {
        session_id: initStore.sessionId,
        session_token: initStore.sessionToken,
        shopee_region: COUNTRY,
      };

      const params = new URLSearchParams(getChatbotApiQuery());
      params.set('session_token', encodeURIComponent(initStore.sessionToken));

      if (UseLiveChatSDKApp.is()) {
        const chatAccessToken = getLiveChatSDKHttpHeaders()['chat-access-token'];
        body.chat_access_token = chatAccessToken;
        params.set('chat_access_token', encodeURIComponent(chatAccessToken));
      }

      const headers = { type: 'application/json' };
      const blob = new Blob([JSON.stringify(body)], headers);

      // 解决 请求报错时不添加交互信息：使用 sendBeacon，或者把该请求的加入到 fetch 方法的白名单中
      navigator.sendBeacon(`${getChatbotHost()}/api/v2/end_session?${params}`, blob);
    } catch (e) { }
  }
};

// 防抖函数
export const debounce = (fn, wait) => {
  let timeout = null;
  return function () {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(fn, wait);
  };
};

// 截流函数
export const throttle = (func, delay, needRemain = true) => {
  let timer = null;
  let startTime = Date.now();
  return function (...args) {
    const curTime = Date.now();
    const remaining = delay - (curTime - startTime);
    const context = this;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else if (needRemain) {
      timer = setTimeout(func, remaining);
    }
  };
};

if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = function (callback) {
    return setTimeout(callback, 17);
  };
}

// 直接到底部
export const directToBottom = () => {
  const scrollEle = getScrollElement();
  scrollEle.scroll({
    top: scrollEle?.scrollHeight,
    left: 0,
  });
};

// 直接到底部 for no shortcut
export const directToBottomNoSC = () => {
  const scrollEle = getScrollElement();

  scrollEle.scroll({
    top: scrollEle?.scrollHeight - scrollEle?.clientHeight - 41,
    left: 0,
  });
};

export const getScreenResolution = () => {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const screenResolution = `${screenWidth}x${screenHeight}`;

  return screenResolution;
};

// 存储需要恢复的live chat上下文
export const saveRecoveryContext = ({ shouldUpdateCurrentUser } = { shouldUpdateCurrentUser: true }, options?: { useCache?: boolean; }) => {

  let oldRecoveryContext = {};

  try {
    oldRecoveryContext = JSON.parse(window.getItem(LIVE_CONTEXT_DATA_KEY));
  } catch {
    // do nothing
  }
  const { currentUser: oldCurrentUser } = oldRecoveryContext;
  const { chatbotUserId } = getSDKToken();

  const newCurrentUser = {
    SPC_EC: getCookie('SPC_EC'),
    shopee_token: getCookie('shopee_token'),
    SPC_U: getCookie('SPC_U'),
    userId: getCookie('userid'),
    chatbotUserId,
  };
  const currentUser = shouldUpdateCurrentUser || !oldCurrentUser ? newCurrentUser : oldCurrentUser;

  if (!initStore.sessionId) {
    asyncReport('【save context】empty sessionId', { level: 'debug' });
  }

  const recoveryContext = {
    currentUser,
    userStore: { ...userStore },
    sessionIDList: [
      {
        type: SessionIDType.PRE_INIT_SESSION,
        id: PRE_INIT_SESSION_ID,
      },
      {
        type: SessionIDType.CHAT_BOT,
        id: initStore.sessionId,
      },
      {
        type: SessionIDType.AGENT,
        id: agentStore.sessionID,
      },
    ],
    chatbotInitData: { ...initStore },
    chatbotHistory: {
      [PRE_INIT_SESSION_ID]: sessionStore.preInitSessionList,
      [initStore.sessionId]: getLastCBHistory(),
    },
    sessionStoreData: { curFunction: sessionStore.curFunction },
    historyStoreData: {
      initMessageId: historyStore.initMessageId,
      beforeMessageId: historyStore.beforeMessageId,
      hasShownLiveChatMsgIds: historyStore.hasShownLiveChatMsgIds,
      hasShownLiveChatMsgSeqIds: historyStore.hasShownLiveChatMsgSeqIds,
    },
    compareStoreData: { ...compareStore },
    others: { searchUrl: initStore.searchUrl },
  };

  // 存储
  saveDataToLocalStorage(LIVE_CONTEXT_DATA_KEY, JSON.stringify(recoveryContext), options);
};

export const clearRecoveryData = () => {

  clearDataFromLocalStorage(LIVE_CONTEXT_DATA_KEY);
  clearDataFromLocalStorage(LIVE_AGENT_DATA_KEY);
};

// 恢复历史记录与agent状态
export const handleRecoveryHistory = async () => {

  if (UseLiveChatSDKApp.is()) {
    const initResult = await initLiveChatSDK();

    if (initResult instanceof Error) {
      initStore.FETCH_DATA();
      return;
    }
  }

  await firstInitStore.initPromise;

  // 用户登录成功回到chatbot
  if (isBank() && isRetainSessionContextSuccess()) {
    return;
  }
  const preComposedRes = await window.preRequest?.preGetComposedInitSession;
  if (preComposedRes?.need_recover_channel === false) {
    initStore.FETCH_DATA(); // 请求ChatBot init_session
    return;
  }

  const recoveryHistory = await getRecoveryHistory();
  // 如果不存在需要恢复的历史记录，直接结束
  if (!recoveryHistory) {
    // 后端通过接口判断需要恢复，但是前端恢复条件未通过
    if (preComposedRes?.need_recover_channel) {
      // 重置，然后重新调用 composed_init_session 接口
      window.preRequest.preGetComposedInitSession = null;

      await firstInitStore.COMPOSED_FETCH_DATA(true);
      initStore.FETCH_DATA(); // 请求ChatBot init_session
    } else {
      initStore.FETCH_DATA(); // 请求ChatBot init_session
    }
    return;
  }

  historyStore.setIsRecoveryHistory(true);

  const { contextData, agentData, realTimeData, sessionIDList } = recoveryHistory;

  const recoveryData = getRecoveryData({
    contextData,
    agentData,
  });

  const { position, hasShowRating } = realTimeData;

  // 弹过rating，则不需要再次弹出
  if (hasShowRating) {
    agentStore.TOGGLE_SHOW_RATING();
  }

  // 恢复显示历史消息，恢复数据状态
  recoveryHistoryAndStoreData(recoveryData, position);
  initSessionApiFinish();

  const virtualCallNeedRecoverHistory = await getDataFromLocalStorage(VIRTUAL_CALL_NEED_RECOVER_HISTORY);
  if (virtualCallNeedRecoverHistory === 'true') {
    // 这里走 chatbot virtual call 的恢复场景
    // 这里把这两个禁用掉 是考虑 vc 过程中  出去 进来 再 出去 进来的场景
    // saveDataToLocalStorage(VIRTUAL_CALL_NEED_RECOVER_HISTORY, 'false');
    // clearRecoveryData();
    initStore.ONLY_UPDATE_SESSION_ID(sessionIDList?.find?.((v) => v?.type === SessionIDType.CHAT_BOT)?.id);
    userStore?.UPDATE_IS_CLICK_VIRTUAL_CALL?.(true); // 标识 拨打了 virtual call
  } else {
    // 原本的 live agent 逻辑
    // [live-chat-split-change]
    safeCallLiveChatSDK((sdk) => {
      const { userName, userId, phone, email, loyaltyTierCode, isLogin, avatar, loyaltyTierName, account_type }
        = userStore;
      sdk?.init?.(
        document.getElementById('app'),
        {
          isRestore: true,
          restoreInfo: recoveryHistory,
          authInfo: {
            userId,
            userName,
            phone,
            email,
            avatar,
            loyaltyTierCode,
            loyaltyTierName,
            accountType: account_type,
          },
          isLogined: isLogin,
        },
        { historyDom: ChatMessagesArea },
        {
          getToken: getSDKToken,
          sendBotMessage: addDialogue,
        },
      );
    });
  }
};

const getRecoveryData = ({ contextData, agentData }) => {
  if (!contextData || !agentData) {
    return {};
  }

  const agentSession = contextData.sessionIDList?.find((item) => item.type === SessionIDType.AGENT);

  agentSession.id = agentData.agentStoreData?.sessionID;

  return {
    ...contextData,
    ...agentData,
  };
};

// 恢复显示历史消息，恢复数据状态
export const recoveryHistoryAndStoreData = (recoveryData, positionFromBubble, options?: {
  skipRecoverAgentStore?: boolean;
}) => {
  // __source__ 为 native 加在 url 上的字段，这里要从 window 上取
  const source = getQueryForm('__source__', window.location.search);
  const isFromPN = source === SourceInUrl.PUSH_NOTIFICATION;

  const {
    sessionIDList = [],
    chatbotHistory = {},
    agentHistory = {},
    agentStoreData = {},
    chatbotInitData = {},
    historyStoreData = {},
    sessionStoreData = {},
    compareStoreData = {},
    userStore: userStoreToRecover = {},
  } = recoveryData;
  const { skipRecoverAgentStore = false } = (options || {});

  // 恢复init_chatbot_session
  initStore.SET_INIT_DATA({
    session_id: chatbotInitData.sessionId,
    session_token: chatbotInitData.sessionToken,
    live_agent_chat_version: chatbotInitData.liveAgentChatVersion,
    hot_questions: chatbotInitData.hotQuestionList,
    avatar: chatbotInitData.botAvatar,
    liveChatAvatar: chatbotInitData.agentAvatar,
    greetings: chatbotInitData.greetings,
    dateTime: chatbotInitData.dateTime,
    hasShowHistoryButtonToast: chatbotInitData.hasShowHistoryButtonToast,
    searchUrl: chatbotInitData.searchUrl,
    abTestSignature: chatbotInitData.abTestSignature,
    chatbotType: chatbotInitData.chatbotType,
    queueAvatar: chatbotInitData.queueAvatar,
    chattingAvatar: chatbotInitData.chattingAvatar,
    isFromPN,
    app_type: chatbotInitData.appType,
    botNickname: chatbotInitData.botNickname,
    hideLiveAgentShortcuts: chatbotInitData.hideLiveAgentShortcuts,
    liveAgentShortcut: chatbotInitData.liveAgentShortcut,
  });
  initStore.UPDATE_HIDE_LIVE_AGENT_SHORTCUTS();
  initStore.UPDATE_SHORTCUT(chatbotInitData.shortcutList);
  initStore.UPDATE_SHORTCUT_TYPE(chatbotInitData.shortcut_type);
  if (isBank()) {
    initStore.UPDATE_PINNED_ANNOUNCEMENT_DATA(chatbotInitData.pinnedAnnouncementData);
    initStore.UPDATE_SHOW_CHATBOT_CSAT(chatbotInitData.showChatbotCsat);
    sessionStore.UPDATE_INTERACTED_WITH_BOT();
  }

  // 恢复场景，不会走骨架屏逻辑，但要保证回到 Chatbot 后如果命中 batch_show 实验，能展示 Shortcuts
  firstInitStore.UPDATE_CAN_SHOW_SHORTCUT(true);
  firstInitStore.UPDATE_CAN_SHOW_INPUT_AREA(true);

  if (!chatbotInitData.sessionId) {
    asyncReport(`【recovery】empty sessionId; chatbotInitData: ${JSON.stringify(chatbotInitData)}`, { level: 'debug' });
  }

  // 非直连premium live chat 再显示时间
  !agentStoreData.connectPremiumLiveChatDirectly && initStore.INIT_DATETIME(chatbotInitData.dateTime);

  // 恢复历史记录
  sessionIDList.forEach((idItem) => {
    const { type, id } = idItem;
    if (!id) {
      return;
    }
    sessionIDListStore.UPDATE_SESSION_ID_LIST(idItem);
    switch (type) {
      case SessionIDType.PRE_INIT_SESSION:
        const preInitSessionList = chatbotHistory[PRE_INIT_SESSION_ID];
        preInitSessionList && addDialogue(preInitSessionList, false, PRE_INIT_SESSION_ID);
        break;
      case SessionIDType.CHAT_BOT:
        chatbotHistory[id] && addDialogue(chatbotHistory[id], false, id);
        break;
      case SessionIDType.AGENT:
        agentHistory[id] && agentStore.ADD_AGENT_DATA_ITEM(agentHistory[id], id);
        break;
      default:
    }
  });

  compareStore.recoverCompareData(compareStoreData);

  historyStore.setInitMessageId(historyStoreData.initMessageId || '');
  historyStore.setBeforeMessageId(historyStoreData.initMessageId || '');
  historyStore.setHasShownLiveChatMsgIds(historyStoreData.hasShownLiveChatMsgIds);
  historyStore.setHasShownLiveChatMsgSeqIds(historyStoreData.hasShownLiveChatMsgSeqIds);

  sessionStore.updateCurFunction(sessionStoreData.curFunction);
  // 恢复agent当前状态
  if (!skipRecoverAgentStore) {
    agentStore.RECOVER_AGENT({ ...agentStoreData, position: positionFromBubble });
  }

  // 清空localStorage，延迟处理，在agentStore.RECOVER_AGENT中

  const { abTestingConfigs, abTestingSignature, newABTestingConfigs } = userStoreToRecover;
  abTestingConfigs && userStore.UPDATE_ABTEST_CONFIG(abTestingConfigs);
  abTestingSignature && userStore.UPDATE_ABTEST_SIGNATURE(abTestingSignature);
  newABTestingConfigs && userStore.UPDATE_NEW_ABTEST_CONFIG(newABTestingConfigs);
  newABTestingConfigs && userStore.UPDATE_HAS_FETCHED_NEW_ABTEST_CONFIG(true);
};

// chatbot恢复contextData，但是没有agent数据
export const recoveryRetainContext = (recoveryData) => {
  // position无意义的
  const position = 1;
  recoveryHistoryAndStoreData(recoveryData, position, { skipRecoverAgentStore: true });
};

// 获取ChatBot最后50条消息
export const getLastCBHistory = (num = 50) => {
  // 因为 首屏优化了 所以 dialogueList 没有 首屏的信息 需要 从 init list 里面取
  // 放弃第一个 是因为第一个是系统时间 正常的恢复场景也会有时间
  const initList = sessionStore?.initList.slice?.(1) ?? [];
  const dialogueList = [...initList, ...sessionStore?.dialogueList];
  // 当前session 取后50条数据
  const recoveryHistory = dialogueList
    .filter((dialogue) => !['TFEModal', 'TFECancelOrder', 'TFEGuaranteeModal'].includes(dialogue.type))
    .slice(-num);
  return recoveryHistory;
};

// 用来配置className
export const classnames = (...arr) => {
  const strArr = [];
  arr.forEach((arrItem) => {
    if (typeof arrItem === 'string') {
      strArr.push(arrItem);
    }

    if (Object.prototype.toString.call(arrItem) === '[object Object]') {
      Object.entries(arrItem).forEach(([key, value]) => {
        if (value) {
          strArr.push(key);
        }
      });
    }
  });

  const str = strArr.join(' ');
  return str;
};

// 页面切出时，转native协助维护轮询
export const handlePageInactive = () => {
  initStore.UPDATE_IS_PAGE_ACTIVE(false);
};

// 页面切回时，恢复过程中的历史消息+恢复轮询
export const handlePageReactive = () => {
  if (initStore.isFromPN && agentStore.hasUnreadMsgWhenPageInactive) {
    scrollToLastUnreadMsg();
  }

  clearPageInactiveData();
  initStore.UPDATE_IS_PAGE_ACTIVE(true);
};

// 隐藏浮窗
export const handleHideBubble = (extraParams = {}) => {
  return toggleShow({
    show: false,
    ...extraParams,
  });
};

// init Native 数据
export const handleInitBubble = () => {
  return toggleShow({
    show: false,
    chat_status: 3, // 0(in-queue) / 1(in-chat) / 3(chat-end)
  });
};

// 全屏展示图片
export const openFullScreenImage = (url) => {
  // https://jira.shopee.io/browse/SPCB-32222
  // fix https://file-proxy.seller.shopee.com/ can't full screen preview
  const changedHostUrl = url?.replace('file-proxy.seller.shopee.com', 'fileproxy.scsusercontent.com');

  bridgeCallFunc(async () => {
    initStore.UPDATE_DONT_SCROLL_TO_BOTTOM(true);
    window.bridgeCallHandler('fullScreenImage', { imageUrls: [changedHostUrl] });
  });
};

// 获取图片文件
export const getImageFileFromBase64 = (image) => {
  // if (!image) {
  //   return;
  // }
  const arr = image.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  const file = new Blob([u8arr], { type: mime });

  return file;
};

// 批量上传图片
export const handleBatchImageUpload = (images) => {
  // 为了保证客服收到的图片顺序与用户端展示的顺序一致
  return Promise.all(
    images.map((image) => {
      return new Promise((resolve) => {
        handleImageUpload(image).then(resolve).catch(resolve);
      });
    }),
  ).then(handleBatchSendMessage);
};

export const handleBatchSendMessage = (data) => {
  try {
    data.forEach((item) => {
      if (item && item.imageUrl) {
        const { imageUrl, curPos } = item;

        batchPostChatMsg(
          agentStore.sessionKey,
          {
            type: 'IMG',
            text: imageUrl,
            params: {
              thumbnail: imageUrl,
              url: imageUrl,
            },
          },
          { imageUrl, curPos },
          ({ code }, extraParams) => {
            if (code === GetMsgResCode.SUCCESS) {
              agentStore.UPDATE_AGENT_DATA_ITEM(
                {
                  image: null,
                  imgUrl: extraParams.imageUrl,
                },
                extraParams.curPos,
              );
            }

            agentStore.UPDATE_AGENT_DATA_ITEM(
              {
                _imgUrl: extraParams.imageUrl, // 用来缓存imgUrl，在消息失败时使用
                loading: false,
                curPos: extraParams.curPos,
                sendMsgError: code !== 0,
              },
              extraParams.curPos,
            );
          },
        );
      }
    });
  } catch (e) { }
};

// 图片发送逻辑，有currentPos代表为重发逻辑
export const handleImageUpload = async (image, currentPos, needSendMsg = false) => {
  try {
    const file = getImageFileFromBase64(image);
    const { size: curImageSize } = file;

    agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADING);

    // 添加图片快速回显
    const curPos = currentPos
      ? currentPos
      : agentStore.ADD_AGENT_DATA_ITEM({
        from: 'user',
        type: 'Image',
        data: {
          imgBlobUrl: window.URL.createObjectURL(file),
          loading: true,
          size: curImageSize,
        },
      });

    // 如果图片超出规定大小
    if (curImageSize > agentStore.maxImageSize) {
      console.warn('如果图片超出规定大小');
      showOverSizeToast(Copywriting.IMAGE_UPLOAD_OVERSIZE, { size: agentStore.maxImageSize / 1024 / 1024 });
      agentStore.UPDATE_AGENT_DATA_ITEM(
        {
          loading: false,
          error: true,
        },
        curPos,
      );

      // 上报埋点
      trackImageFinish({
        isUploadSuccess: false,
        isSendSuccess: false,
      });

      return;
    }

    // 如果会话已结束
    if (agentStore.agentEndedReason) {
      // 回显agent离开文案
      reviewChatEndText();
      agentStore.UPDATE_AGENT_DATA_ITEM(
        {
          loading: false,
          image: null,
        },
        curPos,
      );

      // 上报埋点
      trackImageFinish({
        isUploadSuccess: false,
        isSendSuccess: false,
      });
      return;
    }

    currentPos && agentStore.UPDATE_AGENT_DATA_ITEM({ loading: true }, curPos);

    // 延迟图片发送至chat_history返回后
    // 解决：上传图片失败导致前端中断轮询
    if (agentStore.fireStore.flag !== FIRE_FLAG.FINISH) {
      agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADED);

      agentStore.UPDATE_FIRE_STORE({ images: [...(agentStore.fireStore.images || []), { image, curPos }] });
    } else {
      const imageUrl = await sendImageReq(file, curPos, image, needSendMsg);
      return { imageUrl, curPos };
    }
  } catch (err) {
    console.error(err);
  }
};

export const sendImageReq = async (file: File, curPos: number, image, needSendMsg: boolean) => {
  const imageUrl = await postChatImg(file, curPos, needSendMsg).catch(() => { });

  // 无论上传是否成功，都将上传中的数量减1
  agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADED);

  // 补充真实图片链接
  if (imageUrl) {
    return imageUrl;
  } else {
    agentStore.UPDATE_AGENT_DATA_ITEM(
      {
        curPos,
        image,
        loading: false,
      },
      curPos,
    );

    // 上报埋点
    trackImageFinish({
      isUploadSuccess: false,
      isSendSuccess: false,
    });
  }
};

export const handleFileSend = (file, currentPos) => {
  const { name, size } = file || {};

  // 如果文件不存在
  if (!file) {
    return;
  }

  const curPos = currentPos
    ? currentPos
    : agentStore.ADD_AGENT_DATA_ITEM({
      from: 'user',
      type: 'FileUpload',
      data: {
        title: name,
        size,
        type: getFileExtension(name),
        loading: true,
        file,
      },
    });

  agentStore.UPDATE_AGENT_DATA_ITEM({ curPos }, curPos);

  // 如果会话已经结束
  if (agentStore.agentEndedReason) {
    // 回显agent离开文案
    reviewChatEndText();
    agentStore.UPDATE_AGENT_DATA_ITEM({ loading: false }, curPos);
    return;
  }

  currentPos
    && agentStore.UPDATE_AGENT_DATA_ITEM(
      {
        loading: true,
        file,
      },
      curPos,
    );
};

// 页面切回时，查看是否已activate shopeepay
export const handleIfActivateShopeepay = ({ sessionId, dialogueId, content = '', listPos } = {}) => {
  handleRequest('postShopeePayActivated', {
    session_id: sessionId,
    dialogue_id: dialogueId,
    message_text: content,
  }).then((res) => {
    // activate shopeepay成功：隐藏activate按钮
    if (res) {
      listPos && updateDialogueInfo({ isActivateShopeepayDisabled: true }, listPos);
    } else {
      sessionStore.shiftLoadingDialogue();
    }
  });
};

// 页面切回时，查看是否已activate return/refund
export const handleIfActivateReturnRefund = ({
  sessionId,
  dialogueId,
  content = '',
  orderId,
  listPos,
  nodePointId,
} = {}) => {
  handleRequest('isOrderReturn', {
    session_id: sessionId,
    dialogue_id: dialogueId,
    message_text: content,
    order_id: orderId,
    node_point_id: nodePointId,
  }).then((res) => {
    // activate return/refund 成功，隐藏RR按钮

    if (!res) {
      sessionStore.shiftLoadingDialogue();
      return;
    }

    listPos && updateDialogueInfo({ isActivateReturnRefundDisabled: true }, listPos);
  });
};

// Agent心跳请求
export const sendAgentHeartbeat = async (init) => {
  if (!agentStore.inAgent) {
    return;
  }

  if (init) {
    performanceStore.INIT_HEARTBEAT();
  }

  if (userStore.userId || UseLiveChatSDKApp.is()) {
    const res = await postChatHeartbeat(userStore.userId).catch((err) => { });

    const data = res && isSuccessCode(res.code) && res.data ? res.data : null;
    handleHeartbeat(data, sendAgentHeartbeat);
  } else {
    setTimeout(() => {
      sendAgentHeartbeat(init);
    }, 300);
  }
};

export function getParamsForWebFormSubmissionCheck() {
  const platform = agentStore.defaultEmergencyTemplate.webFormPlatform;
  const params = {
    chat_key: platform === ChannelType.inhouse ? agentStore.webFormUuid : agentStore.shopeeChatKey,
    platform,
    entry_point_id: firstInitStore.entrypointIdInNumber,
    region: COUNTRY.toUpperCase(),
  };
  agentStore.updateWebFormUuid(''); // 查询后重置

  return params;
}

export const handleIfWebformSubmitted = ({ listPos } = {}) => {
  handleRequest('getWebformSubmission', getParamsForWebFormSubmissionCheck()).then((res) => {
    // 提交离线表单 成功，隐藏email按钮
    if (res && !(res instanceof Error) && res?.is_submission_success) {
      agentStore.updateIsOfflineWebformSubmitted(res?.is_submission_success);
      listPos !== null && updateDialogueInfo({ isEmailusDisabled: true }, listPos);
    }
  });
};

export async function handleRedirectBack(option, { dialogueId, listPos } = {}) {
  const { callback, uri_key: uriKey, node_point_id: nodePointId } = option || {};
  const orderId = option?.uri_extra?.order_id;
  if (uriKey === 'request_order_return_page') {
    handleIfActivateReturnRefund({
      orderId,
      nodePointId,
      dialogueId: dialogueId,
      sessionId: initStore.sessionId,
      listPos,
      content: getContent(option),
    });
  }
  if (uriKey === (await getOfflineFormUrlWithParams())) {
    handleIfWebformSubmitted({ listPos });
  }
  if (callback) {
    handleRequest('postMessage', callback);
  }
}

/**
 * @description 转换文件大小，从byte到可读
 * @param {number} bytes 文件大小
 * @param {number} decimalPoint 保留几位
 * @return {string} xxx MB
 */
export const formatFileSize = (bytes, decimalPoint = 2) => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimalPoint)) + ' ' + sizes[i];
};

// 用来展示图片/文件超出指定大小
export const showOverSizeToast = (transKey, params = {}) => {
  bridgeCallFunc(() => {
    Toast.error(replaceParams(getTrans(transKey), params));
  });
};

/**
 * ios 版本是否低于 version
 * @param {string} version
 */
export const isIosVersionLowerThan = (version) => {
  const { userAgent } = window.navigator;

  if (!userAgent) {
    return false;
  }

  const match = userAgent.match(getIosVersionReg);
  const phoneVersion = ((match && match[0]) || '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
  return compareVersions.compare(phoneVersion || '0', version, '<');
};

export const getMessageContent = {
  Msg: (data) => data.content,
  SingleArticle: (data) => data.article?.title,
  MultiArticle: (data) => data.msgContent,
  Options: (data) => data.msgContent,
  Feedback: (data) => data.msgContent,
  Redirection: (data) => data.msgContent,
  Live: (data) => data.msgContent,
  OrderList: () => getTrans(HISTORY_TRANSIFY_KEY.UNREAD_MESSAGE_ORDER),
  QAButton: (data) => data.msgContent,
  SelectOrder: (data) => data.msgContent,
  Login: (data) => data.msgContent,
  General: (data) => data.msgContent,
  NegativeOptions: (data) => data.msgContent,
  StateTransactionList: () => getTrans(HISTORY_TRANSIFY_KEY.UNREAD_MESSAGE_CREDIT_CARD),
  OrderCardWithHQ: () => '',
  HotQuestions: (data) => data.msgContent,
  Image: () => getTrans(HISTORY_TRANSIFY_KEY.UNREAD_MESSAGE_IMAGE),
  FileUpload: () => getTrans(HISTORY_TRANSIFY_KEY.UNREAD_MESSAGE_FILE),
};

export const getDefaultMessageContent = () => getTrans(HISTORY_TRANSIFY_KEY.UNREAD_MESSAGE_DEFAULT);

export const handleClickHistoryButton = () => {
  const { hasShowHistoryButtonToast } = initStore;

  if (hasShowHistoryButtonToast) {
    return;
  }

  Toast.error(getTrans(HISTORY_TRANSIFY_KEY.HISTORY_BUTTON_DISABLED));
  initStore.UPDATE_HAS_SHOW_HISTORY_BUTTON_TOAST(true);
};

export function detectMob() {
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export const setTransform = (el, value) => {
  el.style.transform = value;
  el.style.webkitTransform = value;
};

export const formatPrice = (price) => {
  let formattedPrice;

  try {
    formattedPrice = formatCurrency(COUNTRY, price); // 新地区可能暂不支持
  } catch (error) {
    formattedPrice = formatCurrency('sg', price);
  }

  return formattedPrice;
};

export const replaceHttpLinkWithHttps = (link = '') => {
  const httpStr = 'http:';
  const httpsStr = 'https:';
  link = replaceVideoUrlToMms(link);
  if (link.startsWith(httpStr)) {
    return link.replace(httpStr, httpsStr);
  }
  return link;
};
/**
 * 替换腾讯云 video的链接为内部mms
 *
 * @export
 * @param {string} url
 * @returns
 */
export function replaceVideoUrlToMms(url: string) {
  if (typeof url !== 'string') {
    return url;
  }
  const newOrigin = '//vod-s3.mms.shopee.com';
  const reg = /^(https?:)?\/\/(([^?&\/])*\.myqcloud\.com)/;

  return url.replace(reg, `$1${newOrigin}`);
}

export const getDistanceToBottom = () => {
  const scrollElement = getScrollElement();
  const screenHeight = window.screen.height;
  const scrollHeight = scrollElement.scrollHeight;
  const scrollTop = scrollElement.scrollTop;
  const distanceToBottom = scrollHeight - screenHeight - scrollTop;

  return distanceToBottom;
};

export const scrollToLastUnreadMsg = () => {
  const elements = document.getElementsByClassName('unread-messages');
  const lastElement = elements?.[elements.length - 1];
  const scrollElement = getScrollElement();
  const navBarHeight = getNavbarHeight();

  if (lastElement && scrollElement) {
    setTimeout(() => {
      const distance = lastElement.getBoundingClientRect().top + scrollElement.scrollTop - navBarHeight;

      try {
        scrollElement.scroll({
          top: distance,
          left: 0,
          behavior: 'smooth',
        });
      } catch (err) {
        scrollElement.scrollTop = distance;
        scrollElement.scrollLeft = 0;
      }

      initStore.UPDATE_IS_FROM_PN(false);
    }, 0);
  }
};

export const getMobileSystem = () => {
  const { userAgent } = navigator;

  const isIos = isIosReg.test(userAgent);
  const isAndroid = isAndroidReg.test(userAgent);

  if (isIos) {
    return 'ios';
  } else if (isAndroid) {
    return 'android';
  }

  return '';
};

export const getUaAppType = () => {
  try {
    const app_type = parseInt(navigator.userAgent.match(/app_type=([0-9]+)/i)[1]);
    return app_type;
  } catch {
    return '';
  }
};

// 使用 media sdk 和 upload sdk 的最低版本
export const getNewMediaUploadVersion = () => {
  const { defaultMediaSdkVersion, newMediaCountryVersionMap } = getConfig();

  return newMediaCountryVersionMap.get(`${COUNTRY}-${getMobileSystem()}`) || defaultMediaSdkVersion;
};

export const generateOfflineFormUrl = () => {
  const { app, entryPoint } = getConfig();
  switch (app) {
    case App.Shopee:
    case App.ShopeeLite:
    case App.Partner: // Partner的webform连接保持和Shopee一致
    case App.Mitra:
      let webFormUrl = agentStore.defaultEmergencyTemplate.offlineFormUrl || LIVE_OFFLINE_FORM_URL[COUNTRY];
      if (entryPoint === ENTRY_POINT.ShopeeAPPFoodVNHC || entryPoint === ENTRY_POINT.shopeeFoodHC) {
        if (FOOD_OFFLINE_FROM_URL?.url) {
          webFormUrl = FOOD_OFFLINE_FROM_URL?.url;
        }
      }
      if (agentStore.defaultEmergencyTemplate.webFormPlatform === ChannelType.inhouse) {
        const params = new URLSearchParams({ entryPoint: WEB_FORM_ENTRY_POINT.chatbot });
        return `${webFormUrl}${webFormUrl.includes('?') ? '&' : '?'}${params}`;
      }
      return webFormUrl;

    case App.Driver:
      return getDriverWebformUrl(entryPoint);
    case App.Food:
      return FOOD_OFFLINE_FROM_URL?.url;
    case App.Bank:
      return agentStore.defaultEmergencyTemplate.offlineFormUrl || BANK_OFFLINE_FORM_URL?.url || '';
    default:
      return '';
  }
};

// enquiryType抽离出来queuename和userType(inhouse则直接使用agentStore.userType和enquiryType)
export const separateEnquiryType = (enquiryType) => {
  if (agentStore.chat.channelType === ChannelType.inhouse) {
    return [agentStore.userType, enquiryType];
  }
  const [, userType = '', queue_name = ''] = enquiryType.toString().match(/\S+ Chat-(Seller|Buyer|Driver)-(.+)/) || [];
  return [userType, queue_name];
};

export function formatQueuePosition(position: number): string {
  if (agentStore.queuePositionMax > 0) {
    return position > agentStore.queuePositionMax ? `${agentStore.queuePositionMax}+` : `${position}`;
  }

  return `${position}`;
}

export const isInView = (ele: HTMLElement) => {
  const viewPortWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  // console.log(ele, ele.getBoundingClientRect().left);
  return ele.getBoundingClientRect().left < viewPortWidth;
};

export const shortcutPredictionAvaliable = [
  ShopeeEntryPoint.helpCentre,
  ShopeeEntryPoint.helpCentrePremium,
  ShopeeEntryPoint.mePage,
  ShopeeEntryPoint.mePagePremium,
  ShopeeEntryPoint.ShopeeLiteMePage,
  ShopeeEntryPoint.ShopeeLiteHelpCentre,
].includes(ShopeeEntryPoint[getFromInUrl()]);

export const saveChatbotAndAgentData = () => {
  saveRecoveryContext(); // 缓存 chatbot 数据
  saveAgentData(true); // 缓存 agent 数据
};


const bankUrls = [BANK_POLICY_URL_FOR_UAT_PH, BANK_POLICY_URL_FOR_LIVE_PH];
function isBankUrlMatch(url) {
  return isBank() && bankUrls.some(baseUrl => url.startsWith(baseUrl));
};
